import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminKYC() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/kyc").then((r) => setRows(r.data)).catch(() => {});
  useEffect(load, []);

  const setStatus = async (userId, status) => {
    try {
      await api.post(`/admin/kyc/${userId}/status`, { status });
      toast.success(`KYC ${status}`);
      load();
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">KYC</div>
          <h1 className="font-display text-3xl mt-2">KYC Review Queue</h1>
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Customer</TableHead><TableHead>Aadhaar</TableHead><TableHead>PAN</TableHead><TableHead>City</TableHead><TableHead>Status</TableHead><TableHead></TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-8">No pending KYC records.</TableCell></TableRow>}
              {rows.map((k) => (
                <TableRow key={k.user_id}>
                  <TableCell>{k.customer?.name}<div className="text-xs text-muted-foreground">{k.customer?.email}</div></TableCell>
                  <TableCell>{k.aadhaar_no ? `••${String(k.aadhaar_no).slice(-4)}` : "—"}</TableCell>
                  <TableCell>{k.pan_no || "—"}</TableCell>
                  <TableCell>{k.city || "—"}</TableCell>
                  <TableCell><span className="text-xs px-2 py-1 rounded-full bg-muted">{k.customer?.kyc_status}</span></TableCell>
                  <TableCell className="space-x-2">
                    <Button size="sm" onClick={() => setStatus(k.user_id, "verified")} className="brand-gradient text-white rounded-full" data-testid={`admin-kyc-verify-${k.user_id}`}>Verify</Button>
                    <Button size="sm" variant="outline" onClick={() => setStatus(k.user_id, "rejected")}>Reject</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </div>
    </AdminLayout>
  );
}
